import React from 'react';
import { Icon } from '../Icon';
import { SocialMedia, SocialMediaIcons } from './types';
import {
    renderMenuItemHrefs,
    isMenuLink,
    setHref,
    MenuItem,
} from '../../../lib/landingPage';
import { FooterProps } from '../../../components/landingPage/Footer';

export const renderIcons = (items: SocialMedia[]): SocialMediaIcons[] => {
    return items.map(item => ({
        link: item.link,
        name: item.name,
        icon: <Icon value={item.icon} />,
    }));
};

export const renderFooterMenuItems = (
    items: MenuItem[]
): FooterProps['links'] => {
    return renderMenuItemHrefs(items).map(item => {
        if (isMenuLink(item)) {
            return {
                title: item.title,
                link: setHref(item),
                children: [],
            };
        }
        return {
            title: item.text,
            children: renderFooterMenuItems(item.children),
        };
    });
};
